import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5a58cvuhsd: FaireBrandEntity = {
  token: "b_5a58cvuhsd",
  type: "brand",
  name: "Raw Crunch®",
  avatarUrl:
    "https://cdn.faire.com/fastly/93fe11ec7f6ada380a7a468b4c8135db7bde28bb853a9e0fb90f648ecb545635.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c54305fb4b721a204764c5875f1d5736867143cd2edfbb47c2fade92121032d7.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/93fe11ec7f6ada380a7a468b4c8135db7bde28bb853a9e0fb90f648ecb545635.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c54305fb4b721a204764c5875f1d5736867143cd2edfbb47c2fade92121032d7.jpeg",
  location: "Indian Trail, NC, USA",
  minimumOrderDollars: 28,
  rating: 4.9,
  reviewCount: 20,
  isInsider: true,
  description:
    "“Probably the Best Bar on the Market for Insulin Control” - Dr. Mark Hyman, 15x NY Times best selling author + international leader in functional medicine. \nRanked #1 out of over 100 of snack bars by The Cornucopia Institute - Uncovering the truth behind organic food and advocates for an organic label you can trust.\nIt all started 20 years ago, just two newly married athletes looking for a simple way to make real food convenient. Raw, organic, handmade nutrient-rich bars derived from nature and not altered in any way. Dehydrated rather than cooked in order to maintain their original concentrated nutrients, enzymes and potent antioxidants. Of course, most importantly, they taste really yummy! Living in grandma’s basement made it possible to afford renting a commercial kitchen…talk about motivation. Now two kids, two dogs and a pet pig later, we are still dehydrating the same small batches. We recently moved our Raw Crunch bar factory front and center and added a full-service organic coffee shop with the same quality standards and as our bars! \nThanks a Crunch, \nRoss & Kathy",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:16.683Z",
    importedBy: "entity-db-cli",
  },
};
